module.exports = __webpack_public_path__ + "static/media/R-150XLHD_CrossSection.70cab9b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/de/R-150XLHD_CrossSection.png
// module id = 468
// module chunks = 0